import { useState, useEffect, useMemo, useCallback, FC } from 'react';
import { TextField, Typography } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import { Pagination } from '../../Pages/AnswersPage/constants';
import { translate } from '@utils';
import { ArrowDownAverageIcon } from '@images/icons';

const rowsPerPageOptions: number[] = [
  Pagination.ANSWERS_ON_PAGE_COUNT_FIRST,
  Pagination.ANSWERS_ON_PAGE_COUNT_SECOND,
  Pagination.ANSWERS_ON_PAGE_COUNT_THIRD,
];

interface PaginationPerPageProps {
  handleChangeRowsPerPage: (value) => void;
  rowsPerPage: number;
  total: number;
}

const PaginationPerPage: FC<PaginationPerPageProps> = ({
  handleChangeRowsPerPage,
  rowsPerPage,
  total,
}) => {
  const [answerPerPage, setAnswerPerPage] = useState(rowsPerPage);

  const range = useMemo(() => ({ min: 1, max: total }), [total]);

  useEffect(() => setAnswerPerPage(rowsPerPage), [rowsPerPage]);

  const handleInputChange = useCallback(
    (value: string) => {
      const stringNumber = value || '1';
      if (stringNumber) {
        let number = parseInt(value, 10);
        if (number > range.max) {
          number = range.max;
        }
        if (number < range.min) {
          number = range.min;
        }
        setAnswerPerPage(number);
      }
    },
    [range, rowsPerPage]
  );

  const handleFieldBlur = useCallback(() => {
    handleChangeRowsPerPage(answerPerPage);
  }, [answerPerPage]);

  const renderInput = (params) => {
    return <TextField {...params} type="number" color="secondary" onBlur={handleFieldBlur} />;
  };
  return (
    <div className="pagination-pages">
      <Typography variant="body2">{`${translate('pagination_page_count')}:`}</Typography>
      <Autocomplete
        className="pagination-pages_count"
        inputValue={answerPerPage.toString()}
        value={answerPerPage}
        renderInput={renderInput}
        options={rowsPerPageOptions}
        filterOptions={() => rowsPerPageOptions}
        forcePopupIcon
        popupIcon={<ArrowDownAverageIcon />}
        getOptionLabel={(option) => option.toString()}
        onChange={(event, value) => {
          value >= total ? handleChangeRowsPerPage(total) : handleChangeRowsPerPage(value);
        }}
        onInputChange={(event, newInputValue) => {
          handleInputChange(newInputValue);
        }}
        disableClearable
      />
    </div>
  );
};

export { PaginationPerPage };
